var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentEnquiries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.875,
    height: 15,
    viewBox: "0 0 16.875 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "agent-enquiries",
    d: "M8-3.457a1.344,1.344,0,0,1,.439,1.025v2.9a1.356,1.356,0,0,1-.41,1,1.356,1.356,0,0,1-1,.41H-7.031a1.356,1.356,0,0,1-1-.41,1.356,1.356,0,0,1-.41-1v-2.9A1.344,1.344,0,0,1-8-3.457l2.783-2.607a.146.146,0,0,1,.234,0l.41.439a.146.146,0,0,1,0,.234L-6.328-3.75h3.4l.938,1.875H1.992L2.93-3.75h3.4L4.57-5.391a.146.146,0,0,1,0-.234l.41-.439a.146.146,0,0,1,.234,0ZM7.5.469V-2.344a.456.456,0,0,0-.132-.337.456.456,0,0,0-.337-.132H3.516L2.578-.937H-2.578l-.937-1.875H-7.031a.456.456,0,0,0-.337.132.456.456,0,0,0-.132.337V.469a.456.456,0,0,0,.132.337.456.456,0,0,0,.337.132H7.031A.451.451,0,0,0,7.5.469ZM3.75-9.375a.876.876,0,0,1,.864.586.861.861,0,0,1-.19,1.025L.674-4.014A.978.978,0,0,1,0-3.75a.978.978,0,0,1-.674-.264l-3.75-3.75a.861.861,0,0,1-.19-1.025.876.876,0,0,1,.864-.586h1.875v-3.047a.678.678,0,0,1,.205-.5.678.678,0,0,1,.5-.205H1.172a.678.678,0,0,1,.5.205.678.678,0,0,1,.205.5v3.047ZM0-4.687l3.75-3.75H.938v-3.75H-.937v3.75H-3.75Z",
    transform: "translate(8.438 13.125)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentEnquiries);
export default __webpack_public_path__ + "static/media/agent-enquiries.64b0e5576262348a3a601dff0184bc46.svg";
export { ForwardRef as ReactComponent };